
export default function Features() {
  const features = [
    {
      title: 'Clicks & Drags-and-Drops',
      description: 'Our AI-Empowered spreadsheet like-interface makes the work easier for you to wrangle the data, correct wrong and duplicate values, and identify and group similar strings.'
    },
    {
      title: 'Automated Workflows',
      description: 'Create cleaning repeatability by creating a "Data Recipe".\n\nNext time you need to clean the datasets from the same source, run your pre-saved Data Recipe, and make Bumblebee clean the data for you.'
    },
    {
      title: 'Load Data from Anywhere',
      description: 'Load data from CSV, JSON, Parquet, local, or from a URL. Also, connect to data from databases.\n\nLoad data from any place in just a couple of clicks.'
    }
  ];

  return (
    <section className="bg-[#FFD93D] py-20">
      <div className="container mx-auto px-6 max-w-6xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Decrease your frustration preparing data and focus on get insights
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div key={index} className="text-left">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
